export default "__VITE_ASSET__BcQ$uEZ4__"